import React, { useState, useRef, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";

import { connect } from "react-redux";
import {
  setcolore,
  setdisegno,
  setmateriale,
  setbrand,
  selscroll,
  setopenmain,
} from "../../state/actions";

import Drawer from "@mui/material/Drawer";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import Brightness1Icon from "@mui/icons-material/Brightness1";

import PrintCards from "../PrintCards";

const Tessuti = (props) => {
  const tex = useStaticQuery(
    graphql`
      query navTessuti {
        allAirtableCamicia(sort: { order: ASC, fields: data___prezzo }) {
          edges {
            node {
              data {
                colore
                colore_dettaglio_it
                colore_dettaglio_en
                colore_dettaglio_fr
                colore_dettaglio_es
                materiale
                disegno
                brand
                prezzo
                prezzo_old
                immagine {
                  localFiles {
                    childImageSharp {
                      gatsbyImageData(
                        width: 400
                        height: 250
                        layout: CONSTRAINED
                      )
                    }
                  }
                }
                _id
                codice
                nome
                Path
              }
            }
          }
        }
      }
    `
  );
  const {
    lingua,
    corrente,
    colore,
    setColore,
    disegno,
    setDisegno,
    materiale,
    setMateriale,
    brand,
    setBrand,
    scroll,
    setScroll,
    openMain,
    setOpen,
  } = props;

  const scrollb = useRef(null);
  const scrollc = useRef(scroll);

  useEffect(() => {
    scrollb.current.scrollTo({ top: scroll });
    //scrollc.current.scrollTo({ top: scroll });
  }, [scroll]);

  const trovaScrollTop = () => {
    setScroll(scrollb.current.scrollTop);
  };

  const allPosts = tex.allAirtableCamicia.edges;

  const emptyQuery = "";

  const [state, setState] = useState({
    filteredData: [],
    query: emptyQuery,
  });

  const handleInputChange = (event) => {
    const query = event.target.value;

    const posts = tex.allAirtableCamicia.edges || [];

    const filteredData = posts.filter((post) => {
      const { codice, nome } = post.node.data;
      return (
        codice.toLowerCase().includes(query.toLowerCase()) ||
        nome.toLowerCase().includes(query.toLowerCase())
      );
    });

    setState({
      query,
      filteredData,
    });
  };

  const perColore = (col) => {
    return colore !== "" ? col.node.data.colore.includes(colore) : posts;
  };
  const perDisegno = (dis) => {
    return disegno !== "" ? dis.node.data.disegno === disegno : posts;
  };
  const perMateriale = (mat) => {
    return materiale !== "" ? mat.node.data.materiale === materiale : posts;
  };
  const perBrand = (bra) => {
    return brand !== "" ? bra.node.data.brand === brand : posts;
  };

  const { filteredData, query } = state;
  const hasSearchResults = filteredData && query !== emptyQuery;
  const posts = hasSearchResults ? filteredData : allPosts;

  const percolore = posts.filter(perColore);
  const perdisegno = percolore.filter(perDisegno);
  const permateriale = perdisegno.filter(perMateriale);
  const filtrato = permateriale.filter(perBrand);

  const [aperto, setAperto] = useState(false);

  return (
    <>
      <Drawer
        anchor={"left"}
        open={aperto}
        onClose={() => setAperto(false)}
        hideBackdrop={true}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          zIndex: 10000,
          width: 260,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 260,
            boxSizing: "border-box",
          },
        }}
      >
        <div className="p-3">
          <button
            className="button is-small is-white is-pulled-right"
            onClick={() => setAperto(false)}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </button>
        </div>

        <aside
          className="menu"
          style={{
            height: "calc(100vh - 3rem)",
            overflowY: "scroll",
            padding: "0 1.5rem 1.5rem 1.5rem",
          }}
        >
          <div className="menu-list">
            <input
              style={{ marginBottom: "2rem" }}
              className="input is-rounded is-hidden-mobile"
              type="text"
              aria-label="Search"
              placeholder={lingua.cercaTessuto}
              onChange={handleInputChange}
            />
          </div>

          <div className="menu-list" style={{ marginBottom: "1rem" }}>
            <p className="menu-label">{lingua.colori}</p>
            <button
              onClick={() => setColore("")}
              style={{ marginBottom: "1rem", fontSize: "1rem" }}
              className={
                colore === ""
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.tuttiColori}
            </button>
            <div className="panel-colors ">
              <div className="level is-mobile">
                <div className="level-left">
                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Grigio")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.grigio}
                    >
                      {colore === "Grigio" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#868686" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#868686" }}
                        />
                      )}
                    </span>
                  </button>
                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Blu")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.blu}
                    >
                      {colore === "Blu" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#5d7e9d" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#5d7e9d" }}
                        />
                      )}
                    </span>
                  </button>

                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Nero")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.nero}
                    >
                      {colore === "Nero" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#222222" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#222222" }}
                        />
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="panel-colors ">
              <div className="level is-mobile">
                <div className="level-left">
                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Marrone")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.marrone}
                    >
                      {colore === "Marrone" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#6e5c4d" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#6e5c4d" }}
                        />
                      )}
                    </span>
                  </button>

                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Verde")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.verde}
                    >
                      {colore === "Verde" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#7fc07f" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#7fc07f" }}
                        />
                      )}
                    </span>
                  </button>

                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Bianco")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.bianco}
                    >
                      {colore === "Bianco" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#f2f2f2" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#f2f2f2" }}
                        />
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="panel-colors ">
              <div className="level is-mobile">
                <div className="level-left">
                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Viola")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.viola}
                    >
                      {colore === "Viola" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#a077b3" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#a077b3" }}
                        />
                      )}
                    </span>
                  </button>

                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Arancio")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.arancione}
                    >
                      {colore === "Arancio" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#f0885d" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#f0885d" }}
                        />
                      )}
                    </span>
                  </button>

                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Beige")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.beige}
                    >
                      {colore === "Beige" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#fce8cd" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#fce8cd" }}
                        />
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="panel-colors ">
              <div className="level is-mobile">
                <div className="level-left">
                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Giallo")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.giallo}
                    >
                      {colore === "Giallo" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#f7d764" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#f7d764" }}
                        />
                      )}
                    </span>
                  </button>

                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Rosa")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.rosa}
                    >
                      {colore === "Rosa" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#ecb9d7" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#ecb9d7" }}
                        />
                      )}
                    </span>
                  </button>

                  <button
                    style={{ fontSize: "1rem" }}
                    onClick={() => setColore("Rosso")}
                    className="buttonLinkTras level-item"
                  >
                    <span
                      className="color-icons"
                      data-tooltip={lingua.coloriTip.rosso}
                    >
                      {colore === "Rosso" ? (
                        <TripOriginIcon
                          fontSize="large"
                          style={{ color: "#d25b5c" }}
                        />
                      ) : (
                        <Brightness1Icon
                          fontSize="large"
                          style={{ color: "#d25b5c" }}
                        />
                      )}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="menu-list" style={{ marginBottom: "1rem" }}>
            <p className="menu-label">{lingua.disegni}</p>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setDisegno("")}
              className={
                disegno === ""
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.tuttiDisegni}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setDisegno("Tinta unita")}
              className={
                disegno === "Tinta unita"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.tintaUnita}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setDisegno("Righe")}
              className={
                disegno === "Righe"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.righe}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setDisegno("Quadretti")}
              className={
                disegno === "Quadretti"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.quadretti}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setDisegno("Fantasia")}
              className={
                disegno === "Fantasia"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.fantasia}
            </button>
          </div>

          <div className="menu-list" style={{ marginBottom: "1rem" }}>
            <p className="menu-label">{lingua.materiali}</p>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setMateriale("")}
              className={
                materiale === ""
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.tuttiMateriali}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setMateriale("Cotone")}
              className={
                materiale === "Cotone"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.cotone}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setMateriale("Lino")}
              className={
                materiale === "Lino"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.lino}
            </button>
          </div>

          <div className="menu-list" style={{ marginBottom: "1rem" }}>
            <p className="menu-label">{lingua.brands}</p>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setBrand("")}
              className={
                brand === ""
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              {lingua.tuttiBrands}
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setBrand("Canclini")}
              className={
                brand === "Canclini"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              Canclini
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setBrand("Mileta")}
              className={
                brand === "Mileta"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              Mileta
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setBrand("Thomas Mason")}
              className={
                brand === "Thomas Mason"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              Thomas Mason
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setBrand("Soktas")}
              className={
                brand === "Soktas"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              Soktas
            </button>
            <button
              style={{ fontSize: "1rem" }}
              onClick={() => setBrand("Grandi e Rubinelli")}
              className={
                brand === "Grandi e Rubinelli"
                  ? "buttonLink panel-block has-text-primary"
                  : "buttonLink panel-block"
              }
            >
              Grandi e Rubinelli
            </button>
          </div>
        </aside>
      </Drawer>
      <Drawer
        anchor={"left"}
        open={openMain}
        onClose={() => setAperto(false)}
        hideBackdrop={true}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          width: 320,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 320,
            boxSizing: "border-box",
          },
        }}
      >
        <div className="p-3">
          <button
            className="button is-small is-white"
            onClick={() => setAperto(true)}
          >
            <span className="icon">
              <MenuIcon />
            </span>
            <span className="ml-2">Filtri tessuti</span>
          </button>

          <button
            className="button is-small is-white is-pulled-right"
            onClick={() => setOpen(false)}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </button>
        </div>

        <div
          style={{ height: "calc(100vh - 3rem)", overflowY: "scroll" }}
          ref={scrollc}
          onClick={trovaScrollTop}
        >
          <PrintCards cards={filtrato} lingua={lingua} corrente={corrente} />
        </div>
      </Drawer>

      
        <div className="container-features" style={{ background: "#fff" }}>
          <div className="p-3">
            <button
              className="button is-small is-white"
              onClick={() => setAperto(true)}
            >
              <span className="icon">
                <MenuIcon />
              </span>
              <span className="ml-2">Filtri tessuti</span>
            </button>
          </div>

          <div
            style={{ height: "calc(100vh - 6.6rem)", overflowY: "scroll" }}
            ref={scrollb}
            onClick={trovaScrollTop}
          >
            <PrintCards cards={filtrato} lingua={lingua} corrente={corrente} />
          </div>
        </div>
      
    </>
  );
};

function mapStateToProps(state) {
  return {
    colore: state.shop.colore,
    disegno: state.shop.disegno,
    materiale: state.shop.materiale,
    brand: state.shop.brand,
    scroll: state.shop.scroll,
    openMain: state.shop.openMain,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setColore: (val) => dispatch(setcolore(val)),
    setDisegno: (val) => dispatch(setdisegno(val)),
    setMateriale: (val) => dispatch(setmateriale(val)),
    setBrand: (val) => dispatch(setbrand(val)),
    setScroll: (val) => dispatch(selscroll(val)),
    setOpen: (val) => dispatch(setopenmain(val)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tessuti);
